import {Link, useLocation, useParams} from "react-router-dom";
import React, {useEffect, useMemo, useState} from "react";
import {EditLocalStoragePagesData} from "../../../utils/EditLocalStoragePagesData";
import ArrivalMaterialExportService from "../../../API/organization/ArrivalMaterialExportService";
import Box from "@mui/material/Box";
import {Typography} from "@mui/material";
import ButtonCreate from "../../../components/UI/button/ButtonCreate";
import {
    MaterialReactTable,
    MRT_GlobalFilterTextField,
    MRT_ToggleFiltersButton,
    MRT_ToolbarAlertBanner
} from "material-react-table";
import {MRT_Localization_RU} from "material-react-table/locales/ru";
import {constantsErrorMessages} from "../../../Constants";
import ModalAlert from "../../../components/UI/table/customer-detales/ModalAlert";
import {BreadcrumbsComponent} from "../../../components/UI/breadcrumb/BreadcrumbComponent";
import {ExportingSupplyRequestsModal} from "../../../components/UI/modal/ExportingSupplyRequestsModal";
import {materialPriceUnitField} from "../../../data/MaterialPriceUnitField";

const ExportingSupplyRequests = ({}) => {
    const pathname = useLocation().pathname
    const {id} = useParams();
    const [data, setData] = useState([])
    const [alertData, setAlertData] = useState({});
    const [tableOptions, setTableOptions] = useState({
        pageIndex: 0,
        pageSize: 100,
        totalElements: 0,
        searchData: ""
    })
    const [loading, setLoading] = useState(false)
    const handleModalAlert = (message, type = "error") => {
        setAlertData({
            type: type,
            open: true,
            message: type === "success" ? message : message.response?.data?.message || constantsErrorMessages[message.response?.status] || message.message
        })
    }
    const tableOptionsHandle = (nextState) => {
        setTableOptions(nextState)
        if (nextState.pageSize !== tableOptions.pageSize) {
            EditLocalStoragePagesData(`${pathname}`, "pageSize", nextState.pageSize)
        }
    }

    const getStartPageSize = () => {
        const pagesData = JSON.parse(localStorage.getItem('pagesData')) || {}
        const pageSize = pagesData[`${pathname}`]?.pageSize
        pageSize && setTableOptions((prev) => ({...prev, pageSize: pageSize}))
    }

    useEffect(() => {
        getStartPageSize()
        ArrivalMaterialExportService.get(id).then(function (response) {
            let data = response.data;
            setData(data);
            setTableOptions((prev) => ({...prev, totalElements: response?.data.length}))
        })
            .catch(function (error) {
                handleModalAlert(error);
            });
    }, [])


    const [modalOpen, setModalOpen] = useState(false);
    const [currentEditRowData, setCurrentEditRowData] = useState(null);

    const handleClose = () => {
        setModalOpen(false)
        setCurrentEditRowData(null)
    }
    const handleUpdate = (value) => {
        setLoading(true)
        ArrivalMaterialExportService.update(value, id)
            .then(function (response) {
                setData(response.data)
                handleModalAlert("Данные изменены", 'success')
                handleClose()
            })
            .catch(function (error) {
                handleModalAlert(error)
            })
            .finally(() => setLoading(false))
    }

    const columns = useMemo(
        () => [

            {
                header: 'Наименование колонки',
                accessorKey: 'columnName',
                size: 300,
            },
            {
                header: 'Колонка таблицы',
                accessorKey: 'field',
                size: 300,
                Cell: ({cell}) => materialPriceUnitField[cell.getValue()],
            },
            {
                header: 'Ширина колонки',
                accessorKey: 'columnWidth',
                size: 300,
                Cell: ({row}) => row.original.columnWidth?.toFixed(2),
            },
            {
                header: 'Шрифт заголовка',
                accessorKey: 'headerFontName',
                size: 300,
            },
            {
                header: 'Жирный заголовок',
                accessorKey: 'headerFontBold',
                size: 300,
                Cell: ({row}) => row.original.headerFontBold ? "Да" : "Нет"
            },
            {
                header: 'Курсивный заголовок',
                accessorKey: 'headerFontItalic',
                size: 300,
                Cell: ({row}) => row.original.headerFontBold ? "Да" : "Нет"
            },
            {
                header: 'Размер шрифта заголовока',
                accessorKey: 'headerFontSize',
                size: 300,
            },
            {
                header: 'Шрифт',
                accessorKey: 'valuesFontName',
                size: 300,
            },
            {
                header: 'Жирный текст',
                accessorKey: 'valuesFontBold',
                size: 300,
                Cell: ({row}) => row.original.headerFontBold ? "Да" : "Нет"
            },
            {
                header: 'Курсивный текст',
                accessorKey: 'valuesFontItalic',
                size: 300,
                Cell: ({row}) => row.original.headerFontBold ? "Да" : "Нет"
            },
            {
                header: 'Размер шрифта',
                accessorKey: 'valuesFontSize',
                size: 300,
            },

        ],
        [data, setData],
    );

    return (
        <Box sx={{padding: "0 30px"}}>
            <BreadcrumbsComponent
                page={`${data?.nameSheet}`}
                path={[{name: "Главная", href: "/"}, {name: `Настройки`, href: "/settings"}]}/>
            <Box
                sx={{display: 'flex', justifyContent: "space-between", paddingBottom: "30px", gap: "16px"}}>
                <Box>
                    <Typography sx={{fontSize: "24px", fontWeight: 700}}>
                        {`Настройка прихода материалов ${data?.nameSheet} `}
                    </Typography>
                    <Typography sx={{fontSize: "24px", fontWeight: 700}}>
                        {`Поставщик ${data?.supplier?.name}`}
                    </Typography>
                </Box>
                <ButtonCreate
                    text={"Редактировать настройку"}
                    width={220}
                    onClick={() => setModalOpen(true)}
                    icon={false}
                />
            </Box>
            <MaterialReactTable
                renderTopToolbar={({table}) => {
                    return <Box sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        padding: "7px",
                        backgroundColor: (theme) => table.getSelectedRowModel().rows.length > 0 ? theme.palette.primary.light : "transparent",
                    }}>
                        <MRT_ToolbarAlertBanner table={table}/>
                        <Box sx={{display: "flex"}}>
                            <MRT_ToggleFiltersButton table={table}/>
                            <MRT_GlobalFilterTextField table={table}/>
                        </Box>
                    </Box>
                }}
                selectAllMode={"all"}
                muiTableContainerProps={{
                    sx: {
                        // width: '750px',
                        maxHeight: `calc(100vh - 420px)`
                    }
                }}
                muiTableBodyCellProps={{
                    sx: {
                        p: '0px 0px 0px 10px',
                        m: '0px 0px 0px 0px',
                        border: "none",
                        "& td:after": {
                            "&:hover": {
                                backgroundColor: "red"
                            }
                        },
                        "&:not(:last-of-type)": {
                            borderRight: '1px solid #EAEBEA',

                        },
                        "& li": {
                            listStyleType: "none",
                            "& a": {
                                color: "#006CCC",
                                textDecoration: "none",
                                "&:hover": {
                                    textDecoration: "underline"
                                }
                            }
                        }
                    },
                }}
                muiTableHeadCellProps={{
                    sx: {
                        border: '1px solid #EAEBEA',
                        backgroundColor: "#F5F6FA",
                        padding: "10px",
                        paddingBottom: " 0.2rem",
                        paddingTop: "0.2rem"
                    },
                }}
                muiTableBodyRowProps={({row}) => {
                    return ({
                        sx: () => ({
                            height: '36px',
                            backgroundColor: "white",
                            "&:hover& td:after": {
                                display: "none",
                            },
                            "&:hover": {
                                "& td:after": {
                                    display: "none",
                                },
                            },
                            '&:nth-of-type(even)': {
                                backgroundColor: '#F5F6FA',
                            },
                        })
                    })
                }}

                displayColumnDefOptions={{
                    'mrt-row-actions': {
                        header: "",
                        size: 3,
                        minSize: 3,
                        grow: false,
                    },
                }}
                muiSearchTextFieldProps={{
                    placeholder: `Поиск`,
                    sx: {
                        paddingTop: "5px",
                        paddingBottom: "0px",
                        "& .MuiCollapse-root": {
                            borderRadius: '12px',
                            height: 40, width: 290,
                            "& .MuiSvgIcon-root": {
                                color: "#737478"
                            },
                            '& .MuiOutlinedInput-input': {
                                padding: 0
                            }
                        }
                    },
                    variant: 'outlined',
                }}
                state={{showGlobalFilter: true, pagination: tableOptions,}}
                columns={columns}
                data={data?.columns || []}
                initialState={{
                    sorting: [{id: 'name', desc: false}],
                    columnVisibility: {
                        id: false,
                    },
                    isFullScreen: false,
                    density: "compact",
                    pagination: {pageIndex: 0, pageSize: 100},
                    columnPinning: {left: ['number']}
                }}
                onPaginationChange={(updater) => {
                    tableOptionsHandle(updater(tableOptions));
                }}
                rowCount={tableOptions.totalElements}
                localization={MRT_Localization_RU}
                enableToolbarInternalActions={false}
                enableRowActions={false}
                enableColumnActions={false}

            />
            <ModalAlert
                data={alertData}
                onClose={() => setAlertData((alert) => ({...alert, open: false}))}
            />
            <ExportingSupplyRequestsModal
                open={modalOpen}
                onClose={handleClose}
                initValue={data.columns}
                title={"Изменить настройки прихода"}
                onSubmit={handleUpdate}
                handleModalAlert={handleModalAlert}
                nameSheet={data?.nameSheet}
                loading={loading}
            />
        </Box>
    );
};

export default ExportingSupplyRequests;